// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ArDu","vLegacy":"SelectSecondary_vLegacy__1JtCf","error":"SelectSecondary_error__2iaOT","disabled":"SelectSecondary_disabled__105As"};